import api from '../config';

const path = 'abteilung';

export default {
  get: () => api.get(`${path}`),
};
